import React, { useEffect, useState } from 'react';
import AboutUs from './AboutUs/AboutUS'
import Services from './Services/Services'
import Banners from './Banners/Banners'
import ContactUS from './ContactUS/ContactUS'
import './Home.css'
import MainHeader from '../../Components/Layout/Header/MainHeader/MainHeader'
import logo1 from '../../Assets/Images/logo1.png';
import logo2 from '../../Assets/Images/logo2.png';
import gsap from 'gsap'

function Home() {

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth'
  });
  })
  return (

    <div className="Home">

      <MainHeader type="slider" />
      <AboutUs />
      <Services userType="currentUser" type="" from="home" />
      <Banners />
      <ContactUS />
    </div>

  );
}

export default Home;
